export default {
  id: 'posterList',
  code: 'CN',
  text: {
    '{ticket_amount}': '{ticket_amount}人',
    'Enter Your Text': '输入文字',
    'MMM DD, YYYY': 'YYYY年MM月DD日',
    'ddd, MMM DD YYYY': 'YYYY年MM月DD日 ddd',
    'Delete Content': '删除内容',
    'Are you sure you want to delete the picture above?': '你确定要删除上面的图片吗？',
    'Are you sure you want to delete the picture?': '你确定要删除此图片吗？',
		'Create New Registration Poster':'创建课程报名海报',
		'Create New Basic Poster':'创建普通海报',
		'Create New Poster':'创建课程报名海报',
		'Save': '保存',
		'Publish': '发布',
		'Preview': '预览',
		'Poster Content': '海报内容',
		'Poster Templates': '海报模板',
		'Enter Poster Title': '输入海报标题',
		'Poster Content: Select Picture or Text': '选择图片或文字添加海报内容',
		'Last Updated: ': '最后更改日期：',
		'Add Content': '添加图文',
		'Unable to Edit Published Poster': '已发布的海报无法编辑',
		'Cancel uploading image?' : '取消上传图片？'
  }
}





// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster-archieve/locale.js